import { useContext } from "react"
import RegisterableContext from "components/admin/registerable/context"
import { StackView, Text } from "@planningcenter/tapestry-react"
import AttendeeSelections from "./AttendeeSelections"
import { colors } from "components/shared/admin_colors"
import { func } from "prop-types"

const SignupTimeAttendeeSelections = ({ withSaveStatus }) => {
  const { registerable } = useContext(RegisterableContext)

  return (
    <StackView>
      {registerable.event.eventTimes
        .filter(
          eventTime =>
            registerable.attendees.filter(
              attendee => attendee.attendeeType.signupTimeId === eventTime.id
            ).length > 0
        )
        .map(eventTime => {
          return (
            <StackView marginTop={2} spacing={2} key={eventTime.id}>
              <Text weight={500} color={colors.neutral_700}>
                {eventTime.name}
              </Text>
              <AttendeeSelections signupTimeId={eventTime.id} withSaveStatus={withSaveStatus} />
            </StackView>
          )
        })}
    </StackView>
  )
}

SignupTimeAttendeeSelections.propTypes = {
  withSaveStatus: func
}

export default SignupTimeAttendeeSelections
